import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [formData, setFormData] = useState({
    Username: '',
    Password: '',
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get cookie helper
  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  // Prefill FirstName from cookie
  useEffect(() => {
    const firstnameFromCookie = getCookie("licCustomer");
    if (firstnameFromCookie) {
      setFormData((prev) => ({ ...prev, Username: firstnameFromCookie }));
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData, [name]: value };

      return newData;
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const xmas_token = getCookie("xmas_token");
    const customer_id = getCookie("customer_id");
    const customer_identifier = getCookie("customer_identifier");
    const product_code = getCookie("product_code");
    const licCusomerUsername = getCookie("licCustomer");
    const dimension_identifier = getCookie("dimension");

    if (!xmas_token || !customer_id || !customer_identifier || !product_code || !licCusomerUsername) {
      setError("Missing required data. Please start from the beginning.");
      return;
    }

    const randomDigits = Math.floor(10000 + Math.random() * 90000);
    const order_name = `${randomDigits}_${licCusomerUsername}`;

    const fullPayload = {
      order_name,
      user_name: licCusomerUsername,
      password: formData.Password,
      xmas_token,
      customer_id: customer_identifier,
      customer_indetifier: customer_id,
      dimension_identifier: dimension_identifier,
      product_code,
      subscription_name: "Tiger Bridge Dev",
    };

    try {
      const response = await fetch("https://halr7m1u21.execute-api.us-east-1.amazonaws.com/dev/license", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(fullPayload),
      });

      const result = await response.json();
      console.log("API Response:", result);
      if (!result.success) {
        throw new Error(result.error_message || "Something went wrong");
      }

      navigate("/success", {
        state: { customerName: formData.Username }
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setIsSubmitting(false); // Always re-enable after request
    }
  };

  return (
    <div className="form_wrapper">
      <div className="content">
        <div className="main_content">
          <div class="form_text">
            <p>
              <h3>This Tiger Technology Licensing Server account already exists.</h3>
              <br />
              <br />
              Please enter the password for your account below to create your Tiger Bridge subscription.
              <br />
              Once you add your subscription, you will be prompted to log into your Tiger Technology Licensing Server account where you can access your downloads.
              <br />
            </p>
          </div>
          <div className="form_container">
            {/* Error alert */}
            {error && (
              <div className="alertMessage alert alert-danger d-flex align-items-center" role="alert">
                <img
                  className="alert-icon"
                  src="/img/Account_Authentication_Error_Icon_60x60.svg"
                  alt=""
                />
                <div>{error}</div>
              </div>
            )}
            <form onSubmit={handleFormSubmit}>
              <div className="form-group">
                <label className="form_label">Username*</label>
                <input
                  type="text"
                  name="Username"
                  value={formData.Username}
                  onChange={handleInputChange}
                  className="form_input"
                  required
                  readOnly
                />
              </div>
              <div className="form-group">
                <label className="form_label">Password*</label>
                <input
                  type="password"
                  name="Password"
                  value={formData.Password}
                  onChange={handleInputChange}
                  className="form_input"
                  required
                />
              </div>
              <div className="tiger-btn-placement-alt">
                <button type="submit" className="primary-tiger-button" disabled={isSubmitting}> 
                  {isSubmitting ? "Submitting..." : "Login to complete order"}
                </button>
              </div>
              <div class="tiger-btn-placement-link-alt">
                <a
                  href={`https://license.tiger-technology.com/forgotPassword.htm?load=${encodeURIComponent(formData.Username)}`}
                  className="link-forgot-pass"
                  target="_blank"
                >
                  Forgot password
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
